import { render, staticRenderFns } from "./ConfigBadge.vue?vue&type=template&id=7d7aa798&scoped=true&"
import script from "./ConfigBadge.vue?vue&type=script&lang=js&"
export * from "./ConfigBadge.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBadge.vue?vue&type=style&index=0&id=7d7aa798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7aa798",
  null
  
)

export default component.exports